import React from 'react';
import { FooterNav } from './components/FooterNav/FooterNav';
import { FooterInfo } from './components/FooterInfo/FooterInfo';
import { FooterBrand } from './components/FooterBrand/FooterBrand';
import './Footer.css';

export function Footer() {
  return (
    <footer className="home-footer">
      <div className="home-footer__container">
        <FooterNav />
        <FooterInfo />
        <FooterBrand />
      </div>
    </footer>
  );
}

export default Footer;
